import { fork, take, call } from 'redux-saga/effects';
import { resetPassword } from './actions';
import apiService from '../../api/apiServices/apiService';
import { history } from '../../main';
import { toast } from 'react-toastify';
import i18n from '../../../i18n';

function* resetPass() {
  while (true) {
    const { payload: email }: ReturnType<typeof resetPassword> = yield take(resetPassword.type);
    const { success, reject } = yield call([apiService, apiService.reset], email);

    if (success) {
      toast.success(i18n.t('password_reset_request_sent'));
      history.push('/');
    }

    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* resetSaga() {
  yield fork(resetPass);
}
